import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Icon, message } from 'antd';
import { ethMultiplier } from '../../constants'
import { takeCustomWager as takeCustomWagerApi } from '../../api-calls/customWagers';
import { takeCustomWager as takeContractCustomWager } from '../../contract/CustomWagersController';
import JudgeCustomBetModal from './JudgeCustomBetModal';


Modal.setAppElement('#root')

@observer(["CustomWagerStore", "AuthStore", "UserStore", "web3Store"])
class CustomBetSearchModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen: false,
            submittingBet: true,
            submitClick: false,
            searchInput: "",
            customWagerResult: {},
            loadingResults: true,
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleClickSubmit = this.handleClickSubmit.bind(this);
        this.handleSearchInput = this.handleSearchInput.bind(this);
        this.handleClickTakeBet = this.handleClickTakeBet.bind(this);
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    handleClickSubmit() {
        let self = this;
        this.setState({ submitClick: false })


        if (this.state.searchInput !== "") {
            this.setState({ submitClick: true })
        }
        else if (this.state.searchInput == "") {
            this.setState({ submitClick: false })
        }

        this.props.CustomWagerStore.querySingleCustomWager(this.state.searchInput).then(() =>
            setTimeout(() => {
                self.setState({ loadingResults: false })
            }, 250)
        )
    }

    renderCustomWager() {
        let customWagerList = []
        let customWagers = Array.from(this.props.CustomWagerStore.singleCustomWager.values());
        let auth = this.props.AuthStore.userAuth.auth;
        //       let customWagers = Array.from([{"_id":"5c1d3ef023510f180c46cb5e","bytes32Id":"0x3e2eb6b7857a8334c9f5d0db9dcfa2457ad5848f14c868db0dec507f6e5e6c3e","maker":"5c1a86de396e971564c34b0a","makerETHAddress":"0x625d64b0b5bb7278a8f02c4a17335212bd7ad389","taker":"5c1a84a03dbc7f2e101ff6a5","takerETHAddress":"0xd82e8bfc243d141105f540823290102de1c61477","judge":"0x0000000000000000000000000000000000000000","value":0.05,"odds":100,"endTime":1546370903.932,"reportingEndTime":1546457303.934,"outcomeOne":"I will guess your birthday","outcomeTwo":"No you won't","makerChoice":1,"takerChoice":2,"makerWinVote":0,"takerWinVote":0,"judgeVote":0,"settled":false,"cancelled":false,"paidOut":false,"winner":""}]);
        console.log("auth " + auth);
        for (let customWager of customWagers) {
            if (!customWager.cancelled) {
                if (customWager.maker !== this.props.UserStore.user._id) {
                    customWagerList.push(
                        <div key={customWager._id} className="custom-bet-search-modal-results-item">
                            <div className="custom-bet-search-modal-results-item-grid">
                                <div className="custom-bet-search-modal-results-item-grid-item">
                                    <div><span>Creator</span>{customWager.makerETHAddress}</div>
                                    <div><span>Value</span>{(customWager.value / ethMultiplier).toFixed(4)}</div>
                                    <div><span>Odds</span>{customWager.odds / 100}</div>
                                    <div><span>Potential Win</span>{customWager.odds > 99 ?
                                        (((customWager.value) / (customWager.odds / 100)) / ethMultiplier).toFixed(4)
                                        : ((((customWager.value) * Math.floor(100 / customWager.odds))) / ethMultiplier).toFixed(4)}</div>
                                    <div><span>First Outcome</span>{customWager.outcomeOne}</div>
                                    <div><span>Second Outcome</span>{customWager.outcomeTwo}</div>
                                    <div><span>Judge</span>{customWager.judge} <JudgeCustomBetModal auth={auth} wager={customWager} /></div>
                                </div>
                                <div className="custom-bet-search-modal-results-item-grid-item-button">
                                    {auth ? customWager.taker === "" ? <button
                                        onClick={() => {
                                            this.handleClickTakeBet(
                                                customWager.bytes32Id,
                                                customWager._id,
                                                customWager.judge,
                                                customWager.value,
                                                customWager.odds)
                                        }} className="custom-btn-success">Take bet</button> : <button className="custom-btn-disabled">Bet already taken</button> : <button className="custom-btn-disabled">You must be logged in to take</button>}
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    customWagerList.push(
                        <div key={customWager._id} className="custom-bet-search-modal-results-item">
                            <div className="custom-bet-search-modal-results-item-grid">
                                <div className="custom-bet-search-modal-results-item-grid-item">
                                    <div><span>Creator</span>{customWager.makerETHAddress}</div>
                                    <div><span>Value</span>{(customWager.value / ethMultiplier).toFixed(4)}</div>
                                    <div><span>Odds</span>{customWager.odds / 100}</div>
                                    <div><span>Potential Win</span>{
                                        customWager.odds > 99 ?
                                            (((customWager.value) / (customWager.odds / 100)) / ethMultiplier).toFixed(4)
                                            : ((((customWager.value) * Math.floor(100 / customWager.odds))) / ethMultiplier).toFixed(4)
                                    }</div>
                                    <div><span>First Outcome</span>{customWager.outcomeOne}</div>
                                    <div><span>Second Outcome</span>{customWager.outcomeTwo}</div>
                                    <div><span>Judge</span>{customWager.judge} <JudgeCustomBetModal auth={auth} wager={customWager} /></div>
                                </div>
                                <div className="custom-bet-search-modal-results-item-grid-item-button">
                                    <button className="custom-btn-disabled">You can't take your own bet</button>
                                </div>
                            </div>
                        </div>
                    )
                }
            } else {
                customWagerList.push(
                    <div key={customWager._id} className="custom-bet-search-modal-results-item">
                        <div className="custom-bet-search-modal-results-item-grid">
                            <div className="custom-bet-search-modal-results-item-grid-item">
                                <div>THIS BET HAS BEEN CANCELLED!</div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        return customWagerList;
    }

    handleSearchInput = (e) => {
        this.setState({ searchInput: e.target.value })
    }

    handleClickTakeBet(bytes32Id, wagerId, judgeEthAddress, wagerValue, wagerOdds) {
        console.log("bytes32Id :" + bytes32Id)
        console.log("wagerId :" + wagerId)
        const { AuthStore, UserStore } = this.props;
        let self = this;
        let judgeAddress = judgeEthAddress;
        console.log("judgeEthAddress :" + judgeAddress)
        let wagerBytes32Id = bytes32Id;
        let wagerIdObj = wagerId;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let wagerValueObj = wagerValue;
        let wagerOddsObj = wagerOdds;
        const ethMultiplier = 1000000000000000000;
        let takerAddress = UserStore.user._id;
        let takerETHAddress = UserStore.user.publicAddress;

        return takeContractCustomWager(wagerBytes32Id, judgeAddress, (wagerValueObj) * (wagerOddsObj / 100)).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! Bet not taken.");
                } else {
                    return takeCustomWagerApi(
                        authToken,
                        takerAddress,
                        takerETHAddress,
                        wagerIdObj,
                        wagerValueObj
                    ).then(() => {
                        message.success("Bet taken!");
                        UserStore.updateUser(authToken);
                        self.props.CustomWagerStore.querySingleCustomWager(self.state.searchInput);
                        self.closeModal();
                    })
                }
            });
    }

    render() {
        let modalContent = "";

        let modalContentPreSearch = <div className="custom-bet-search-modal-content">
            <div className="custom-bet-search-modal-content-wrap" style={{ transform: 'translate(0px, 10%)' }}>
                <div className="custom-bet-search-modal-form-wrap"></div>
                <div className="custom-bet-search-modal-title">Search for a custom a bet</div>
                <div className="custom-bet-search-modal-form">
                    <div className="custom-bet-search-modal-form-field">
                        <div className="custom-bet-search-modal-form-field-input">
                            <input onChange={this.handleSearchInput} value={this.state.searchInput} className="custom-input" placeholder="Enter Bet ID" />
                        </div>
                        <div className="custom-bet-search-modal-form-field-input-search">
                            <button className="custom-btn-primary" onClick={this.handleClickSubmit} style={{ width: '100%' }}>Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        let modalContentPostSearch = <div className="custom-bet-search-modal-content">
            <div className="custom-bet-search-modal-content-wrap" style={{ transform: 'translate(0px, 0px)' }}>
                <div className="custom-bet-search-modal-form-wrap" style={{ marginBottom: '15px' }}>
                    <div className="custom-bet-search-modal-title">Search for a custom a bet</div>
                    <div className="custom-bet-search-modal-form">
                        <div className="custom-bet-search-modal-form-field">
                            <div className="custom-bet-search-modal-form-field-input">
                                <input onChange={this.handleSearchInput} value={this.state.searchInput} className="custom-input" placeholder="Enter Bet ID" />
                            </div>
                            <div className="custom-bet-search-modal-form-field-input-search">
                                <button className="custom-btn-primary" onClick={this.handleClickSubmit} style={{ width: '100%' }}>Search</button>
                            </div>
                        </div>
                    </div>
                </div>
                <h2 style={{ marginTop: '10px' }}>Result for: {this.state.searchInput}</h2>
                <div className="custom-bet-search-modal-results-wrap">
                    {!this.state.loadingResults ?
                        this.renderCustomWager()
                        : <div style={{ fontSize: '54px', textAlign: 'center' }}><Icon type='loading' /></div>}
                </div>
            </div>
        </div>

        if (this.state.submitClick) {
            modalContent = modalContentPostSearch;
        } else {
            modalContent = modalContentPreSearch;
        }
        return (
            <div style={{ paddingRight: "14px" }} className="custom-bets-search-modal-open-btn" >
                <button className="custom-btn-primary" onClick={this.openModal}><Icon type="search" />  Search For Bet</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Custom Bet Modal"
                    className="custom-bet-modal"
                    overlayClassName="custom-bet-modal-overlay"
                >
                    <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
                    {modalContent}
                </Modal>
            </div>
        );
    }
}

export default inject('store')(observer(CustomBetSearchModal));


// WEBPACK FOOTER //
// ./src/components/modals/CustomBetSearchModal.js